import classNames from 'classnames'
import type { FC, HTMLAttributes } from 'react'

type GridLayoutProps = HTMLAttributes<HTMLDivElement> & {
  variant?: 'default' | 'narrow'
}

const GridLayout: FC<GridLayoutProps> = ({ children, className, variant = 'default', ...rest }) => (
  <div
    className={classNames(
      'col-span-full',
      {
        'md:col-start-2 md:col-span-10 xl:col-start-3 xl:col-span-8': variant === 'default',
        'md:col-start-4 md:col-span-6 xl:col-start-5 xl:col-span-4': variant === 'narrow',
      },
      className
    )}
    data-testid="grid-layout"
    {...rest}
  >
    {children}
  </div>
)

export default GridLayout
